/**
 * Created by fers on 05.02.16.
 */

import {ButtonGroup} from 'react-bootstrap';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import EditButton from './EditButton.react';
import ResizePureComponent from '../app/ResizePureComponent.react';

import React from 'react';
import PropTypes from 'prop-types';
import * as BrowserPermission from "../BrowserPermission";

import './DetailToolBar.scss';

export default class extends ResizePureComponent {
    static propTypes = {
        asMenu: PropTypes.bool,
        children: PropTypes.node,
        data: PropTypes.object.isRequired,
		editButtonTitle: PropTypes.any,
        metadata: PropTypes.object.isRequired,
		noEdit: PropTypes.bool,
        organisationId: PropTypes.string,
        urlMapping: PropTypes.object.isRequired,
		vertical: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);

		this.state = {
			asMenu: props.asMenu,
			vertical: !props.asMenu && props.vertical
		};
    }

	onResize() {
		let propsVertical = !this.props.asMenu && this.props.vertical;

		if (propsVertical) {
			if (window.innerWidth < 1000) {
				this.setState({
					asMenu: true,
					vertical: false
				});
			}
			else {
				this.setState({
					asMenu: this.props.asMenu,
					vertical: propsVertical
				});
			}
		}
	}

    static contextTypes = {
        router: PropTypes.object
    };

    getEditButton() {
		if (this.props.noEdit) {
			return null;
		}
        let { asMenu, metadata, data, urlMapping, editButtonTitle} = this.props;

        if (metadata.canUserUpdate(data) && metadata.canUpdate(BrowserPermission.getPermissionObject(), data, this.props.organisationId)) {
            if (this.props.asMenu) {
                return <li><EditButton asLink={asMenu} data={data} metadata={metadata} organisationId={this.props.organisationId} title={editButtonTitle} urlMapping={urlMapping} /></li>;
            } else {
                return <EditButton data={data} metadata={metadata} organisationId={this.props.organisationId} title={editButtonTitle} urlMapping={urlMapping} />;
            }
        }
    }

    render() {
        if (this.state.asMenu) {
            return (
                <div className="dropdown pull-right">
                    <button aria-expanded="true" aria-haspopup="true" className="btn btn-inline dropdown-toggle" data-toggle="dropdown" id="dropdownMenu1" type="button">
                        <span className="fa-lg glyphicon glyphicon-option-vertical" />
                    </button>
                    <ul aria-labelledby="dropdownMenu1" className="dropdown-menu DetailToolBar-dropdown">
                        {this.getEditButton()}
                        {React.Children.map(this.props.children, ((item, idx) => {
                            return <li key={idx}>{item}</li>;
                        }))}
                    </ul>
                </div>
            );
		} else if (this.state.vertical) {
			return (
				<ButtonGroup className="DetailToolBar-vertical" vertical>
					{this.getEditButton()}
					{this.props.children}
				</ButtonGroup>
			);
        } else {
            return (
                <div className="btn-toolbar" role="toolbar">
                    <div className="btn-group" role="group">
                        {this.getEditButton()}
                        {this.props.children}
                    </div>
                </div>
            );
        }
    }
}
